import { ColorInput, Popover, ColorPicker, Text, Divider } from "@mantine/core";
import { useEffect, useState } from "react";

import classes from "./ColorInputV2.module.css";
import { useTranslation } from "react-i18next";

export const ColorInputV2 = (props) => {

    const { t } = useTranslation();
    const [colorValue, setColorValue] = useState(props?.defaultValue || '');

    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        if (props?.defaultValue) {
            setColorValue(props.defaultValue);
        }
        if (props?.suggestions) {
            setSuggestions(JSON.parse(props?.suggestions)?.map(rgbToHex));
        }

    }, [props.defaultValue]);

    const rgbToHex = (rgbString) => {
        if (!rgbString || typeof rgbString !== 'string') return null; 
        const rgbArray = rgbString.split(',').map(Number);
        const toHex = (value) => value?.toString(16).padStart(2, '0');
        return `#${toHex(rgbArray[0])}${toHex(rgbArray[1])}${toHex(rgbArray[2])}`;
    };


    const onChange = (color) => {
        setColorValue(color);
        props?.onChange(color);
    }

    return (
        <Popover radius="md" width="target" position={ props?.position || "bottom" } withArrow shadow="md">
            <Popover.Target>
                <ColorInput classNames={classes} withEyeDropper={true} value={colorValue} onChangeEnd={setColorValue} radius="md" variant="filled" {...props} withPicker={false} />
            </Popover.Target>
            <Popover.Dropdown>
                <ColorPicker
                    format="hex"
                    withPicker={true}
                    fullWidth
                    size="xs"
                    defaultValue={props?.defaultValue}
                    value={colorValue}
                    onChange={onChange}
                />
                {
                    suggestions?.length > 0  && (
                        <>
                            <Divider my="sm" />
                            <Text>{t('colorInput.suggestions')}</Text>
                            <ColorPicker
                                format="hex"
                                withPicker={false}
                                fullWidth
                                size="xs"
                                defaultValue={props?.defaultValue}
                                onChange={onChange}
                                swatches={suggestions}
                            />
                        </>
                    )
                }

            </Popover.Dropdown>
        </Popover>
    )
}